import React, { MouseEvent, useState, useEffect } from 'react';
import i18n from '../../../translate/i18n';

import Select from '../../Form/Select';
import Input from '../../Form/Input';
import Textarea from '../../Form/Textarea';
import Radio from '../../Form/Radio'
import Alert from '../../../helpers/Alert';
import moment from 'moment';

//SERVICES
import { getRoutes } from '../../../services/LocationService';
import { getListInsurence } from '../../../services/InsurenceCompanyService';
import { getListProperty } from '../../../services/insurancePropertyService';
import { getUsers } from '../../../services/UserService';
import GoogleMapReact from "google-map-react";
import UploadFiles from 'components/Form/UploadFiles';

interface TypeProps {
  data: any,
  handleSelectChange: Function,
  handleInputChange: Function,
  setData: Function,
}
interface TypeSelectData {
  _id: string,
  name: string,
}
interface TypePropertyData {
  _id: string,
  name: string,
  natureza: TypeSelectData[]
}

export default function Registro({ data, handleSelectChange, handleInputChange, setData }: TypeProps) {
  moment.locale('pt-br');

  const [listInsurence, setListInsurence] = useState<TypeSelectData[]>([]);
  const [listProperty, setListProperty] = useState<TypePropertyData[]>([]);

  const [users, setUsers] = useState<any[]>([]);

  const [isAdmin, setIsAdmin] = useState<boolean>(false)


  //busca perfil do usuario
  useEffect(() => {
    try {
      const user: any = localStorage.getItem('user');
      const { id, name, role } = JSON.parse(user);

      if (role === 'manager') {
        setIsAdmin(true);
        getUsers(`?manager=${id}`).then(res => {
          const data = res.data.rows;
          const usersNew = data.map((user: any) => {
            return {
              _id: user.id,
              name: user.name
            }
          })
          setUsers(usersNew)
        })
      }
    }
    catch (err) {
      console.log(err)
    }
  }, [])

  //busca lista de seguradoras
  useEffect(() => {
    getListInsurence().then((res: TypeSelectData[]) => {
      setListInsurence(res)
    }).catch((err: any) => console.log(err))
  }, [])


  //busca lista de bens do segurado
  useEffect(() => {
    getListProperty().then((res: TypePropertyData[]) => {
      setListProperty(res)
    }).catch((err: any) => console.log(err))
  }, [])

  const linkRouter = (event: any) => {
    event.preventDefault();
    const win = window.open(`https://www.google.com.br/maps/dir/${data?.start_address}/${data?.end_address}/`, "_blank");
    win?.focus();
  }

  // calcula a rota
  const calcRouter = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    try {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        const { lat, lng } = data.location.geometry.location;

        const origin = `${latitude},${longitude}`;
        const destination = `${lat},${lng}`;

        getRoutes(origin, destination).then((res: any) => {
          if (res.data.status === "OK") {
            const { distance, duration, start_address, end_address } = res?.data?.routes[0]?.legs[0];
            const newData = { distance: distance.text, duration: duration.text, start_address, end_address }
            setData({ ...data, ...newData });
          }
        }).catch(err => {
          Alert(false, 'Não foi possível calcular a rota');
          console.log(err)
        })
      });

    } catch (error) {
      Alert(false, 'Não foi possível calcular a rota')
    }
  }


  return (
    <div className='container-box'>
      <h5>{i18n.t<string>('edit.registry')}</h5>
      <hr />
      <form >

        {
          isAdmin &&
          <Select
            title="Designar Processo para Sindicante"
            data={users}
            value={data.prestador}
            setSelected={(value: string) => { handleSelectChange('prestador', value) }}
            required={true}
          />
        }
        <Radio
          title="Tipo de sindicância"
          data={[
            { _id: 'remota', name: 'Remota' },
            { _id: 'completa', name: 'Completa' },
            { _id: 'pericia', name: 'Perícia' },
          ]}
          value={data?.tipoSindicancia || ''}
          setSelected={(value: string) => { handleSelectChange('tipoSindicancia', value) }}
        />
        <Input
          name="createdAt"
          label="Data de abertura da OS"
          type="datetime-local"
          placeholder={'Data de abertura da OS'}
          data={moment(data?.createdAt).format('yyyy-MM-DDThh:mm')}
          setData={() => { }}
          disabled={true}
        />
        <Input
          name="dateAreaSindicancia"
          label="Data de entrada na área de sindicância"
          type="datetime-local"
          placeholder={'Data de entrada na área de sindicância'}
          data={moment(data?.dateAreaSindicancia).format('yyyy-MM-DDThh:mm')}
          setData={() => { }}
          disabled={true}
        />
        {/*
        <Input
          name="datePrazo"
          label="Previsão para entrega da O.S."
          type="datetime-local"
          placeholder={'Previsão para entrega da O.S.'}
          data={moment(data?.datePrazo).format('yyyy-MM-DDThh:mm')}
          setData={handleInputChange}
        />
        */}
        <Input
          name="analistaSinistro"
          label="Analista responsável (área de sinistros)"
          type="text"
          placeholder={'Nome do analista responsável (área de sinistros)'}
          data={data?.analistaSinistro || ''}
          setData={handleInputChange}
        />
        <Select
          title="Seguradora"
          data={listInsurence}
          value={data?.seguradora}
          setSelected={(value: string) => { handleSelectChange('seguradora', value) }}
        />
        <Input
          name="sindicancia"
          label="Código da Sindicância"
          type="text"
          placeholder={'Sindicância'}
          data={data?.sindicancia || ''}
          setData={handleInputChange}
        />
        <Input
          name="segurado"
          label="Nome do Segurado"
          type="text"
          placeholder={'Segurado'}
          data={data?.segurado || ''}
          setData={handleInputChange}
        />
        <Input
          name="vistoria"
          label="Código da Vistoria"
          type="text"
          placeholder={'Vistoria'}
          data={data?.vistoria || ''}
          setData={handleInputChange}
        />
        <Input
          name="sinistro"
          label="Código do Sinistro"
          type="text"
          placeholder={'Sinistro'}
          data={data?.sinistro || ''}
          setData={handleInputChange}
        />
        <Select
          title="Bem Segurado"
          data={
            listProperty.map((a: TypePropertyData) => {
              return { _id: a._id, name: a.name }
            })
          }
          value={data?.bemSegurado}
          setSelected={(value: string) => { handleSelectChange('bemSegurado', value) }}
        />

        <Input
          name="natureza"
          label="Natureza"
          type="text"
          placeholder={'Natureza'}
          data={data?.natureza || ''}
          setData={handleInputChange}
        />

        <Input
          name="veiculo"
          label="Veículo"
          type="text"
          placeholder={'Veículo'}
          data={data?.veiculo || ''}
          setData={handleInputChange}
        />

        <Input
          name="placa"
          label="Placa"
          type="text"
          placeholder={'Placa'}
          data={data?.placa || ''}
          setData={handleInputChange}
        />

        <Input
          name="indenizacao"
          label="Indenização"
          type="text"
          placeholder={'Indenização'}
          data={data?.indenizacao || ''}
          setData={handleInputChange}
        />

        <Radio
          title="Prioridade"
          data={[
            { _id: 'Regular', name: 'Regular' },
            { _id: 'Alta', name: 'Alta' },
          ]}
          value={data?.prioridade || ''}
          setSelected={(value: string) => { handleSelectChange('prioridade', value) }}
        />

        <Textarea
          name="registro_observacao"
          label="Observações"
          placeholder={'Observações'}
          data={data?.registro_observacao || ''}
          setData={handleInputChange}
          required={false}
        />

        <h5 style={{ marginTop: 15 }}>{i18n.t<string>('edit.files')}</h5>

        {
          data.id &&
          <UploadFiles
            name="images"
            label="Inserir imagens e/ou documentos dos tipos: PNG, JPEG, JPG e PDF"
            osId={data?.id}
            etapa={'registro'}
          />
        }
        {/*}
      <Input
        name="resultado"
        label="Resultado"
        type="text"
        placeholder={'Resultado'}
        data={data?.resultado || ''}
        setData={handleInputChange}
      />
      <Textarea
        name="causa"
        label="Causa"
        placeholder={'Causa'}
        data={data?.causa || ''}
        setData={handleInputChange}
      />
      */}

        {data?.tipoSindicancia !== 'remota' &&
          <>
            <hr />
            <button className='btn btn-secundary w-100' onClick={calcRouter}>Calcular trajeto</button>
            <Input
              name="start_address"
              label="Ponto de partida"
              type="text"
              placeholder={'Ponto de partida'}
              data={data?.start_address || ''}
              setData={handleInputChange}
              disabled={true}
            />
            <Input
              name="end_address"
              label="Destino"
              type="text"
              placeholder={'Destino'}
              data={data?.end_address || ''}
              setData={handleInputChange}
              disabled={true}
            />
            <Input
              name="distance"
              label="Distância"
              type="text"
              placeholder={'Distância'}
              data={data?.distance || ''}
              setData={handleInputChange}
              disabled={true}
            />
            <Input
              name="duration"
              label="Duração"
              type="text"
              placeholder={'Duração'}
              data={data?.duration || ''}
              setData={handleInputChange}
              disabled={true}
            />
            <button
              className='btn btn-secundary w-100'
              onClick={(event) => linkRouter(event)}
              disabled={!data?.start_address && !data?.end_address}
            > Iniciar Rota</button>
          </>
        }
        {/*
      <div id='map'>
        <GoogleMapReact
          bootstrapURLKeys={{ key: process.env.REACT_APP_API_GOOGLE || '' }}
          defaultCenter={{
            lat: data?.location?.geometry?.location?.lat || null,
            lng: data?.location?.geometry?.location?.lng || null,
          }}
          defaultZoom={14}
        >
          <MarkerComponent
            finalizado={false}
            lat={data?.location?.geometry?.location?.lat || null}
            lng={data?.location?.geometry?.location?.lng || null}
          />
        </GoogleMapReact>
      </div>
      */}

      </form >

    </div>
  )
}
